import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ProcessFlowFullscreenPage } from '@/pages/processes/all-processes/ProcessFlowFullscreenPage';
import { createEntityBreadcrumbLoader } from '@/lib/entity-breadcrumb';
import { HEATMAP_VIEW_MODES } from '@/lib/processFlowHeatmap';

const flowFullscreenSearchSchema = z.object({
  viewMode: z.enum(HEATMAP_VIEW_MODES).optional().catch(undefined)
});

export const Route = createFileRoute('/$slug/processes/all-processes/$processId/flow-fullscreen')({
  loader: createEntityBreadcrumbLoader('process', 'processId', ' - Flow'),
  component: RouteComponent,
  validateSearch: flowFullscreenSearchSchema
});

function RouteComponent() {
  const { processId } = Route.useParams();
  const { viewMode } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ProcessFlowFullscreenPage
      processId={processId}
      viewMode={viewMode ?? 'standard'}
      onViewModeChange={(mode) =>
        navigate({
          search: (prev) => ({ ...prev, viewMode: mode === 'standard' ? undefined : mode }),
          replace: true
        })
      }
    />
  );
}
